import { useEffect } from "react";

// react-snap prerenders the site with Puppeteer using the user agent
// "ReactSnap". Tree-Nation's widget script uses syntax that crashes that
// (older) headless browser with a fatal "SyntaxError: Unexpected token '?'"
// page error, which kills the entire prerender crawl after the first page —
// every other route then ends up serving a stale build. Skip the widget
// during that crawl only; real visitors' browsers render it normally.
const isPrerendering =
  typeof navigator !== "undefined" && /ReactSnap/.test(navigator.userAgent);

const TreeNationWidget = () => {
  useEffect(() => {
    if (isPrerendering) return;

    const existingScript = document.querySelector(
      'script[src="https://widgets.tree-nation.com/js/widgets/v3/widgets.min.js"]'
    );

    if (!existingScript) {
      const script = document.createElement("script");
      script.src =
        "https://widgets.tree-nation.com/js/widgets/v3/widgets.min.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  if (isPrerendering) return null;

  return (
    <div className="flex justify-center pt-2 pb-4 mb-16 lg:mb-0">
      <div
        data-widget-type="offset-website"
        data-tree-nation-code="7493d2ca40b83a04"
        data-lang="en"
        data-theme="dark-monochrome"
      />
    </div>
  );
};

export default TreeNationWidget;